/**

 * Cache Bustered
 * Version ID for statc resources
 */

declare const KP_VERSION: string;

export const CACHE_VERSION = KP_VERSION;
